import collection_spyxfamilly from "../images/products/collection-spyxfamilly.webp";
import collection_tokyoghoul from "../images/products/collection-tokyoghoul.webp";
// Posters
import posters1 from "../images/products/posters/posters-1.webp";
import posters2 from "../images/products/posters/posters-2.webp";
import aot_poster from "../images/products/posters/aot.webp";
import messi_poster from "../images/products/posters/messi.webp";
import thewalkingdead__poster from "../images/products/posters/thewalkingdead.webp";
// figures
import figures1 from "../images/products/figures/figures1.webp";
import theweatcher_figures from "../images/products/figures/theweatcher.webp";
import godofwar_figures from "../images/products/figures/godofwar.webp";
// Stickers
import veg_stickers from "../images/products/stickers/veg.webp";
import aot_stickers from "../images/products/stickers/aot.webp";
import deathnote_stickers from "../images/products/stickers/deathnote.webp";
import demonslayer_back_stickers from "../images/products/stickers/demonslayer-back.webp";
import demonslayer_stickers from "../images/products/stickers/demonslayer.webp";
import dragonball_stickers from "../images/products/stickers/dragon-ball.webp";
import mha_stickers from "../images/products/stickers/mha.webp";
import jujutsu_back_stickers from "../images/products/stickers/jujutsu-back.webp";
import jujutsu_stickers from "../images/products/stickers/jujutsu.webp";
import motivation_stickers from "../images/products/stickers/motivation.webp";
import motivation_back_stickers from "../images/products/stickers/motivation-back.webp";
import naruto_stickers from "../images/products/stickers/naruto.webp";
import stickers1 from "../images/products/stickers/stickers-1.webp";
import stickers2 from "../images/products/stickers/stickers-2.webp";
import stickers3 from "../images/products/stickers/stickers-3.webp";

const products = [
 {
  id: "01",
  productName: "Jujutsu Kaisen",
  imgUrl: jujutsu_stickers,
  imgBackUrl: jujutsu_back_stickers,
  category: "stickers",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 4.7,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.5,
 },

 {
  id: "02",
  productName: "Violete Evergarden",
  imgUrl: veg_stickers,
  category: "stickers",
  price: 4000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },

 {
  id: "03",
  productName: "Naruto",
  imgUrl: naruto_stickers,
  category: "stickers",
  price: 2000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "04",
  productName: "My Hero Academy",
  imgUrl: mha_stickers,
  category: "stickers",
  price: 2000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },


 {
  id: "05",
  productName: "Demon Slayer",
  imgUrl: demonslayer_stickers,
  imgBackUrl: demonslayer_back_stickers,
  category: "stickers",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "06",
  productName: "Dragon Ball",
  imgUrl: dragonball_stickers,
  category: "stickers",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "07",
  productName: "Motivation Stickers",
  imgUrl: motivation_stickers,
  imgBackUrl: motivation_back_stickers,
  category: "stickers",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "08",
  productName: "Death Note",
  imgUrl: deathnote_stickers,
  category: "stickers",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
//  posters
 {
  id: "09",
  productName: "messi",
  imgUrl: messi_poster,
  category: "posters",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "10",
  productName: "The Walking Dead",
  imgUrl: thewalkingdead__poster,
  category: "posters",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "11",
  productName: "Attack On Titan",
  imgUrl: aot_poster,
  category: "posters",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
//  
 {
  id: "12",
  productName: "Attack On Titan",
  imgUrl: aot_stickers,
  category: "stickers",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 
 {
  id: "13",
  productName: "The Weatcher",
  imgUrl: theweatcher_figures,
  category: "figures",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "14",
  productName: "God Of War",
  imgUrl: godofwar_figures,
  category: "figures",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "15",
  productName: "Spy X Familly",
  imgUrl: collection_spyxfamilly,
  category: "collection",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },
 {
  id: "16",
  productName: "Tokyo Ghoul",
  imgUrl: collection_tokyoghoul,
  category: "collection",
  price: 3000,
  shortDesc:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur iure quas illo voluptates labore tempore!",
  description:
   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio nostrum accusantium iste, voluptas cumque provident! Consequatur officiis animi rem tempore voluptate cumque hic similique aperiam ut consectetur distinctio repudiandae quia quam quos, quas illo, iusto, necessitatibus odio veniam exercitationem quis voluptatibus debitis laboriosam! Esse debitis obcaecati blanditiis at impedit quibusdam!",
  reviews: [
   {
    rating: 2.8,
    text: "this item is very good .",
    name:'jackie chan'
   },
   {
        name:'jackie chan',
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
   },
  ],
  avgRating: 4.7,
 },

];

export default products;
